import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="回到顶部"
      className="fixed bottom-8 right-8 z-50 w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer hover:bg-primary-600 transition-all duration-300 shadow-lg"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}